import React from 'react';
import { CheckIcon } from 'lucide-react';
import { moduleIncludes, modules } from '../data/content';
export function Modules() {
  return <section className="bg-slate-50 px-5 py-16 sm:py-20" data-id="element-127" data-mp="1r4slcy07ysqe">
      <div className="mx-auto max-w-6xl" data-id="element-128" data-mp="1vwk8szo2wicb">
        <h2 className="mx-auto max-w-2xl text-center font-display text-3xl font-black leading-tight text-navy-800 sm:text-4xl" data-id="element-129" data-mp="1vxu63mn3xmhw">
          Inside the Main Volume — 6 Complete Coaching Modules
        </h2>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-130" data-mp="147ph1aoekbac">
          {modules.map(module => <article key={module.number} className="flex h-full flex-col rounded-xl border border-slate-200 border-l-4 bg-white p-6 shadow-sm" style={{
          borderLeftColor: module.color
        }} data-id="element-131" data-mp="189ayl9bvtdqv">
              <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-slate-400" data-id="element-132" data-mp="2omiymxa3kji1">
                <span aria-hidden="true" data-id="element-133" data-mp="2tk1c90z27mwd">{module.dot}</span> Module{' '}
                {module.number}
              </p>
              <h3 className="mt-2 font-display text-lg font-extrabold leading-snug text-navy-800" data-id="element-134" data-mp="1trvvrbmz0fr">
                {module.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600" data-id="element-135" data-mp="3ozshlk6yryfk">
                {module.description}
              </p>
              <ul className="mt-auto flex flex-wrap gap-1.5 pt-5" data-id="element-136" data-mp="3k1h7r9go5nxc">
                {module.tags.map(tag => <li key={tag} className="rounded bg-slate-100 px-2 py-1 text-[11px] font-medium text-slate-600" data-id="element-137" data-mp="3f2efkplsfc6s">
                    {tag}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-12 rounded-2xl border border-slate-200 bg-white p-7" data-id="element-138" data-mp="31bhm6wk1eqyo">
          <p className="text-center text-xs font-bold uppercase tracking-[0.18em] text-gold-dark" data-id="element-139" data-mp="2wa233a1f6uix">
            What every module includes
          </p>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-140" data-mp="2red0exu3sxie">
            {moduleIncludes.map(item => <li key={item} className="flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2.5 text-[13px] font-medium text-slate-700" data-id="element-141" data-mp="2mn7xzlq5jp2c">
                <CheckIcon className="h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-142" data-mp="2cpbnmw51gy5a" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}